import { format } from "date-fns";
import { TitleSubtitleChildren } from "features/History/HistoryDetail/components/TitleSubtitleChildren";
import { CustomResponsiveHStack } from "features/History/utils/HistoryCustomTableStyle";
import { EventState } from "features/History/utils/utils";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Box, DropsBadge, Spacer } from "shared/components/Spor";

export type Status = "Friskmeldt" | "Åpen" | "Erstattet" | "Ubehandlet";
export type TableDetailAccordionButtonProps = {
  version: number;
  date: Date;
  state: EventState;
  title: string;
  subtitle: string;
  description: string;
  user: string;
};

export const TableDetailAccordionButton: FC<
  TableDetailAccordionButtonProps
> = ({ version, date, state, title, subtitle, description, user }) => {
  const { t } = useTranslation();
  return (
    <h2 style={{ width: "100%" }}>
      <CustomResponsiveHStack gap="0.2rem" width="100%" py="1rem" px="0.5rem">
        <TitleSubtitleChildren
          width="6rem"
          column
          title={`${t("Versjon")} ${version}`}
        />
        <TitleSubtitleChildren
          column
          title={format(date, "dd.MM.yyyy")}
          subtitle={format(date, "HH:mm")}
        />
        <Box mx="30px" w="125px">
          <DropsBadge semantics={state.semantics}>{state.label}</DropsBadge>
        </Box>
        <TitleSubtitleChildren
          style={{
            // Behaviour: Use max 3 lines and show "..." at overflow
            overflow: "hidden",
            display: "-webkit-box",
            WebkitLineClamp: "3",
            WebkitBoxOrient: "vertical",
            whiteSpace: "normal",
          }}
          column
          title={title}
          subtitle={subtitle}
        />
        <TitleSubtitleChildren
          style={{
            // Behaviour: Use max 4 lines and show "..." at overflow
            overflow: "hidden",
            display: "-webkit-box",
            WebkitLineClamp: "4",
            WebkitBoxOrient: "vertical",
            whiteSpace: "normal",
          }}
          column
          marginLeft="2rem"
          marginRight="1rem"
          subtitle={description}
        />
        <Spacer />
        <Box w="300px">
          <TitleSubtitleChildren
            column
            title={t("Opprettet av")}
            subtitle={user}
            style={{
              // Behaviour: Use max 3 lines and show "..." at overflow
              overflow: "hidden",
              display: "-webkit-box",
              WebkitLineClamp: "3",
              WebkitBoxOrient: "vertical",
              whiteSpace: "normal",
            }}
            mr="1rem"
          />
        </Box>
      </CustomResponsiveHStack>
    </h2>
  );
};
